import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivityEntry } from './activity-log.types';

//REV-21366 — activity log (Pure View). No store, no HTTP, no sorting, no formatting.

@Component({
    selector: 'abcp-activity-log',
    templateUrl: './activity-log.component.html',
    styleUrls: ['./activity-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbcpActivityLogComponent {
    @Input() entries: ActivityEntry[] = [];
    /** Total number for the header — comes in, is never counted from `entries`. */
    @Input() totalCount = 0;
    /** Header context, e.g. "Konto 1000". */
    @Input() accountLabel = '';
    /** The whole list is loading. */
    @Input() loading = false;
    @Input() error = false;
    /**
     * REV-21869 (#165, A-C10) — a closing whose only run is `PLANNED` HAS a run, its trail is just
     * not written yet. "Keine Aktivitäten vorhanden" reads as "nobody started it" and invites a
     * second, rejected start (AK-16) — so the empty state renders a DIFFERENT sentence, same slot.
     */
    @Input() plannedOnly = false;
    /** More entries exist → button at the end of the list. */
    @Input() canLoadMore = false;
    /** Button busy → its arrow spins, the button is disabled and stays silent. */
    @Input() loadingMore = false;

    @Output() loadMore = new EventEmitter<void>();

    readonly skeletonRows = [1, 2, 3, 4];

    get isEmpty(): boolean {
        return this.entries.length === 0;
    }

    /** Agent or human is the only difference between two entries. */
    actorIconClass(entry: ActivityEntry): string {
        return entry.actor.type === 'agent' ? 'bot-icon' : 'user-icon';
    }

    trackById(_index: number, entry: ActivityEntry): string {
        return entry.id;
    }

    onLoadMoreClick(): void {
        if (this.loadingMore) {
            return;
        }
        this.loadMore.emit();
    }
}
